/**
 * Functions specific to making API requests using Axios, e.g. Facade pattern,
 * interceptors etc.
 */

import axios from "axios";

import { API_ENDPOINTS, REQUEST_CONFIG } from "../../config";

// Set up default axios configuration
axios.defaults.withCredentials = REQUEST_CONFIG.withCredentials;
axios.defaults.xsrfCookieName = REQUEST_CONFIG.xsrfCookieName;
axios.defaults.xsrfHeaderName = REQUEST_CONFIG.xsrfHeaderName;
axios.defaults.timeout = REQUEST_CONFIG.timeout;

/**
 * Axios facade pattern to fetch data from the API.
 *
 * @param {String} url The API url to fetch data from
 * @param {Function} setData The state setter function to store the API response data
 * @returns API response data (see API documentation for details)
 */
export async function getAPIData(url, setData) {
  return await apiRequest(url, null, { method: "GET" }, setData);
}

export async function postAPIData(url, setData, body, config) {
  return await apiRequest(url, body, { method: "POST", ...config }, setData);
}

export async function apiRequest(url, body, config, callback) {
  const apiUrl = API_ENDPOINTS.BASE;

  // Extract the CSRF token from cookies
  const csrfToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken"))
    ?.split("=")[1];

  const safeConfig = config || {};
  const { headers: requestHeaders, ...axiosRest } = safeConfig;

  const response = await axios({
    url: `${apiUrl}${url}`,
    ...REQUEST_CONFIG,
    ...axiosRest,
    data: body || undefined,
    headers: {
      "X-CSRFTOKEN": csrfToken || "",
      ...(requestHeaders || {}),
    },
  });
  const responseData = response?.data || response;
  if (callback) {
    callback(responseData);
  }
  return responseData; // Ensure the response is returned
}

export async function egnyteApiRequest(url, body, config, callback) {
  const apiUrl = API_ENDPOINTS.EGNYTE;

  const response = await axios({
    url: `${apiUrl}${url}`,
    ...REQUEST_CONFIG,
    data: body || undefined,
    headers: {},
    ...(config || {}),
  });
  const responseData = response?.data || response;
  if (callback) {
    callback(responseData);
  }
  return responseData; // Ensure the response is returned
}
